import tipoUsuario from './tipo-usuario';
import { criarContextoAcesso } from './acessos';

const regrasDeRota = [
  ['home', ctx => true],
  ['alterar-senha', ctx => (ctx.usuario.tipoUsuario !== tipoUsuario.Aluno) && (ctx.usuario.tipoUsuario !== tipoUsuario.Funcionario) && (ctx.usuario.tipoUsuario !== tipoUsuario.AcessoEspecial) && (ctx.usuario.tipoUsuario !== tipoUsuario.FornecedorWebNovo)],
  ['alterar-email', ctx => (ctx.usuario.tipoUsuario !== tipoUsuario.Aluno) && (ctx.usuario.tipoUsuario !== tipoUsuario.Funcionario) && (ctx.usuario.tipoUsuario !== tipoUsuario.AcessoEspecial) && (ctx.usuario.tipoUsuario !== tipoUsuario.Fornecedor) && (ctx.usuario.tipoUsuario !== tipoUsuario.FornecedorWeb) && (ctx.usuario.tipoUsuario !== tipoUsuario.FornecedorWebNovo)],
  ['liberar-solicitacoes', ctx => ctx.liberarSolicitacoes],
  ['mensagem', ctx => ctx.mensagemSistema],
  ['mensagem-compra.relatorio', ctx => ctx.mensagemSistema],
  ['termino-projetos', ctx => ctx.terminoProjeto],
  ['notificacoes', ctx => ctx.usuario.tipoUsuario === tipoUsuario.Coordenador],
  ['acompanhamento-projeto', ctx => ctx.acompanhamentoProjeto],
  ['importacao-projeto', ctx => ctx.solImportacaoProjetos],
  ['relatorio-tecnico-projeto', ctx => ctx.relatorioTecnicoProjeto],
  ['aprovar-pesquisa-preco', ctx => ctx.aprovarPesquisaPreco],
  ['aprovar-passagem', ctx => ctx.aprovarPesquisaPreco],
  ['solicitacao-bolsa-atividades', ctx => ctx.solBolsaAtividade],
  ['contrato', ctx => ctx.usuarioLiberarContratos],
  ['contrato.liberados', ctx => ctx.utilizarLiberacaoContrato],
  ['solicitacao-doacao-realizadas', ctx => ctx.doacoesRealizadas],
  ['solicitacao-evento-realizados', ctx => ctx.eventosRealizados],
  ['projeto', ctx => ctx.infoProjeto],
  ['compra', ctx => ctx.usuarioLiberarCompras],
  ['compra.compra', ctx => ctx.usuarioLiberarCompras],
  ['compra.importacao', ctx => ctx.usuarioLiberarCompras],
  ['liberar-pedidos-compra', ctx => ctx.liberarPedidosCompra],
  ['liberar-provisoes-pagamento', ctx => ctx.liberarProvisoesPagamento],
  ['liberar-pagamento', ctx => ctx.liberarPagamento],
  ['solicitacao-curso-evento-matricular', ctx => ctx.matricularAlunos],
  ['pedido', ctx => ctx.pedidoCompra],
  ['importacao', ctx => ctx.solImportacao],
  ['importacao.principal', ctx => ctx.solImportacao],
  ['solicitacao-importacao', ctx => ctx.solImportacao],
  ['solicitacao-reembolso-pf-atividade', ctx => ctx.solReembolsoAtividade || ctx.prestacaoContasPessoaFisica],
  ['solicitacao-adiantamento', ctx => ctx.solAdiantamento],
  ['solicitacao-bolsa', ctx => ctx.solBolsa],
  ['solicitacao-cancelamento-contrato', ctx => ctx.solCancelamentoContrato],
  ['solicitacao-contratacao-pessoal', ctx => ctx.solContratacaoPessoal],
  ['solicitacao-compra', ctx => ctx.solCompras],
  ['solicitacao-importacao-projeto', ctx => ctx.solImportacaoProjetos],
  ['solicitacao-curso-evento-servico', ctx => ctx.solCursoEventoServico],
  ['solicitacao-reembolso-pf', ctx => ctx.solReembolso],
  ['solicitacao-reembolso-estrangeiro', ctx => ctx.solReembolsoEstrangeiro],
  ['solicitacao-faturamento-pfpj', ctx => ctx.solFaturamentoPFPJ],
  ['solicitacao-faturamento-multiservicos', ctx => ctx.solFaturamentoMC],
  ['solicitacao-faturamento-estrangeiro-pf', ctx => ctx.solFaturamentoEstrangeiroPF],
  ['solicitacao-faturamento-estrangeiro-pj', ctx => ctx.solFaturamentoEstrangeiroPJ],
  [ctx => ctx.rotaSolicitacaoPF, ctx => ctx.solPagamentoPessoaFisica],
  [ctx => ctx.rotaSolicitacaoPJ, ctx => ctx.solPagamentoPessoaJuridica],
  [ctx => ctx.rotaSolicitacaoEstrangeiroPF, ctx => ctx.solPagamentoEstrangeiroPF],
  [ctx => ctx.rotaSolicitacaoEstrangeiroPJ, ctx => ctx.solPagamentoEstrangeiroPJ],
  [ctx => ctx.rotaSolicitacaoPFRateio, ctx => ctx.solPagamentoPessoaFisicaRateio],
  [ctx => ctx.rotaSolicitacaoPJRateio, ctx => ctx.solPagamentoPessoaJuridicaRateio],
  ['solicitacao-reembolso-terceiro', ctx => ctx.solReembolsoTerceiro],
  ['solicitacao-transferencia', ctx => ctx.solTransferencia],
  ['relatorio.aplicacoes-financeiras', ctx => ctx.relLancamentoAplicacao || ctx.relLancamentoAplicacaoFuncionario],
  ['relatorio.contas-pagar-receber', ctx => ctx.relContasPagarReceber || ctx.relContasPagarReceberFuncionario],
  ['relatorio.controle-item', ctx => ctx.relControleItem],
  ['relatorio.impostos', ctx => ctx.relImpostosPorProjeto],
  [ctx => ctx.rotaRelatorioFinanceiro, ctx => ctx.relLancamentoFinanceiro || ctx.relLancamentoFinanceiroFuncionario],
  ['relatorio.lancamentos-resumo', ctx => ctx.relLancamentoFinanceiroResumo],
  ['relatorio.lancamentos-projetos', ctx => ctx.relLancamentoFinanceiroProjeto],
  ['relatorio.lancamentos-cambio', ctx => ctx.relLancamentoCambio],
  ['relatorio.mensalidades-agrupadas-por-aluno', ctx => ctx.relMensalidadeAluno],
  ['relatorio.pedidos-compra', ctx => ctx.relPedidoCompra],
  ['relatorio.protocolos', ctx => ctx.relProtocolos || ctx.relProtocolosFuncionario],
  ['relatorio.provisoes', ctx => ctx.relProvisoes],
  ['relatorio.rubricas', ctx => ctx.relRubrica || ctx.relRubricaFuncionario],
  ['relatorio.saldos', ctx => ctx.relSaldos],
  ['relatorio.subrubricas', ctx => ctx.relSubrubrica || ctx.relSubrubricaFuncionario],
  ['relatorio.taxasProjeto', ctx => ctx.relProvisoes && ctx.fusp],
  ['relatorio.verificacao-de-pagamentos', ctx => ctx.relVerificacaoLancamento],
  ['relatorio.verificacao-de-pagamentos-fornecedor', ctx => ctx.usuario.tipoUsuario === tipoUsuario.Fornecedor],
  ['fornecedor.alterar', ctx => ctx.usuario.tipoUsuario === tipoUsuario.Fornecedor],
  ['fornecedor.contrato', ctx => ctx.usuario.tipoUsuario === tipoUsuario.Fornecedor],
  ['fornecedor.solicitacao-pesquisa-preco', ctx => ctx.usuario.tipoUsuario === tipoUsuario.Fornecedor && ctx.usuario.informarPesquisaWEB],
  ['fornecedor.pesquisa-preco', ctx => ctx.usuario.tipoUsuario === tipoUsuario.Fornecedor && ctx.usuario.informarPesquisaWEB],
  ['web-fornecedor.alterar', ctx => ctx.usuario.tipoUsuario === tipoUsuario.FornecedorWeb || ctx.usuario.tipoUsuario === tipoUsuario.FornecedorWebNovo],
  ['pessoa-fisica.alterar', ctx => ctx.usuario.tipoUsuario === tipoUsuario.PessoaFisica],
  ['pessoa-fisica.mensalidades', ctx => ctx.usuario.tipoUsuario === tipoUsuario.PessoaFisica],
  ['pessoa-fisica.assinatura', ctx => ctx.usuario.tipoUsuario === tipoUsuario.PessoaFisica && ctx.habilitarAssinaturaEletronica],
  ['pessoa-fisica.irpf', ctx => ctx.usuario.tipoUsuario === tipoUsuario.PessoaFisica],
  ['web-pessoa-fisica.alterar', ctx => ctx.usuario.tipoUsuario === tipoUsuario.PessoaFisicaWeb || ctx.usuario.tipoUsuario === tipoUsuario.PessoaFisicaWebNovo],
  ['acesso-especial-relatorio.controle-item', ctx => acessoEspecial(ctx).relControleItem],
  ['acesso-especial-relatorio.lancamentos', ctx => acessoEspecial(ctx).relLancamentoFinanceiro],
  ['acesso-especial-relatorio.rubricas', ctx => acessoEspecial(ctx).relRubrica],
];

function acessoEspecial(ctx) {
  return ctx.usuario.acessoEspecialPermissoes || {};
}

function nomesCandidatos(nomeRota) {
  const partes = nomeRota.split('.');
  const candidatos = [];

  for (let i = partes.length; i > 0; i--) {
    candidatos.push(partes.slice(0, i).join('.'));
  }

  return candidatos;
}

function avaliar(condicao, ctx) {
  try {
    return !!condicao(ctx);
  } catch (e) {
    return false;
  }
}

function nomeDaEntrada(chave, ctx) {
  if (typeof chave !== 'function') return chave;

  try {
    return chave(ctx);
  } catch (e) {
    return null;
  }
}

export function rotaPermitida(nomeRota, usuario, configuracao) {
  if (!nomeRota || !usuario) return false;

  const ctx = criarContextoAcesso(usuario, configuracao);
  const candidatos = nomesCandidatos(nomeRota);

  for (let i = 0; i < candidatos.length; i++) {
    const entradas = regrasDeRota.filter(entrada => nomeDaEntrada(entrada[0], ctx) === candidatos[i]);

    if (!entradas.length) continue;

    return entradas.some(entrada => avaliar(entrada[1], ctx));
  }

  return false;
}

export function analisarDestino(router, destino, usuario, configuracao) {
  const analise = {
    caminho: destino,
    rota: null,
    trechos: 0,
    exigeAuth: false,
    regraUsada: null,
    tipoUsuario: usuario ? usuario.tipoUsuario : null,
    permitido: false,
    motivo: '',
  };

  if (!router || !destino || !usuario) {
    analise.motivo = 'sem rota, destino ou usuário';
    return analise;
  }

  let resolvida;

  try {
    resolvida = router.resolve(destino).route;
  } catch (e) {
    analise.motivo = 'endereço não pôde ser interpretado';
    return analise;
  }

  if (!resolvida || !resolvida.matched.length) {
    analise.motivo = 'endereço não corresponde a nenhuma tela';
    return analise;
  }

  analise.rota = resolvida.name || null;
  analise.trechos = resolvida.matched.length;
  analise.exigeAuth = resolvida.matched.some(registro => registro.meta && registro.meta.auth);

  if (!analise.exigeAuth) {
    analise.motivo = 'tela pública, fora do redirecionamento';
    return analise;
  }

  if (!resolvida.name) {
    analise.motivo = 'tela sem nome de rota';
    return analise;
  }

  const ctx = criarContextoAcesso(usuario, configuracao);
  const candidatos = nomesCandidatos(resolvida.name);

  for (let i = 0; i < candidatos.length; i++) {
    const entradas = regrasDeRota.filter(entrada => nomeDaEntrada(entrada[0], ctx) === candidatos[i]);

    if (!entradas.length) continue;

    analise.regraUsada = candidatos[i];
    analise.permitido = entradas.some(entrada => avaliar(entrada[1], ctx));
    analise.motivo = analise.permitido ? 'liberado' : 'regra da tela negou este usuário';

    return analise;
  }

  analise.motivo = 'tela sem regra cadastrada em acesso-rota.js';

  return analise;
}

export function destinoPermitido(router, destino, usuario, configuracao) {
  return analisarDestino(router, destino, usuario, configuracao).permitido;
}

export default { rotaPermitida, destinoPermitido, analisarDestino };



// WEBPACK FOOTER //
// ./FrontEnd/js/acesso-rota.js